/* global document, jQuery */
import 'core-js/stable';
// import 'regenerator-runtime/runtime';

import compact from 'lodash/compact';
import map from 'lodash/fp/map';
import React from 'react';
import { render } from 'react-dom';

import DonationForm from './components/DonationForm';

(() => {
  jQuery(once('friends-donate', 'body')).each(() => {
    if (document.querySelector('.friends-donation-form')) {
      map((form) => {
        const buttonText = form.getAttribute('data-button-text');
        const classyFormUrl = form.getAttribute('data-classy-form-url');
        const donationType = form.getAttribute('data-default-type');
        const entityId = form.getAttribute('data-entity-id');
        const monthlyValues = compact(form.getAttribute('data-monthly-values').split(';'));
        const oneTimeValues = compact(form.getAttribute('data-one-time-values').split(';'));
        /* eslint-disable react/jsx-filename-extension */
        render(<DonationForm
          buttonText={buttonText}
          classyFormUrl={classyFormUrl}
          donationType={donationType}
          entityId={entityId}
          monthlyValues={monthlyValues}
          oneTimeValues={oneTimeValues}
        />, form);
      }, document.querySelectorAll('.friends-donation-form'));
    }
  });
})();
